import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios"; //import store from "store";

import Authentication from "./Authentication";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
var ignoreTokenURLs = ["/token", "/ResetPassword", "/ForgotPassword", "/api/Account", "/api/RequestAccess"];

var Config =
/*#__PURE__*/
function () {
  function Config(onInvalidToken) {
    _classCallCheck(this, Config);

    this.onInvalidToken = onInvalidToken;
    this.refreshPromises = [];
    this.setupInterceptors();
    this.refreshingToken = false;
    this.retryCount = 0;
    this.MAXRETRYCOUNT = 3;
  }

  _createClass(Config, [{
    key: "setupInterceptors",
    value: function setupInterceptors() {
      var me = this;
      axios.interceptors.request.use(function (config) {
        var attachToken = true;

        for (var i in ignoreTokenURLs) {
          if (config.url.indexOf(ignoreTokenURLs[i]) > -1) attachToken = false;
        }

        if (attachToken) {
          // if (Authentication.TokenValid()) {
          var token = Authentication.GetToken();

          if (token) {
            config.headers.Authorization = "Bearer ".concat(token);
          }
        }

        config.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
        config.headers.Pragma = "no-cache";
        config.headers.Expires = 0;
        return config;
      }, function (error) {
        return error;
      });
      axios.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        if (error.response && 401 === error.response.status && error.response.headers["token-expired"]) {
          if (Authentication.GetToken() != null && me.retryCount != me.MAXRETRYCOUNT) {
            return new Promise(function (_resolve, reject) {
              if (!me.refreshingToken) {
                me.refreshingToken = true;
                me.retryCount++;
                Authentication.RefreshToken().then(function (x) {
                  me.retryCount = 0;
                  me.refreshingToken = false;
                  me.refreshPromises.forEach(function (p) {
                    p.resolve();
                  });
                  me.refreshPromises = [];
                }).catch(function (ex) {
                  me.refreshingToken = false;
                  me.onInvalidToken();
                  me.refreshPromises.forEach(function (p) {
                    p.reject(ex);
                  });
                  me.refreshPromises = [];
                });
              }

              me.refreshPromises.push({
                resolve: function resolve() {
                  axios(error.config).then(_resolve, reject);
                },
                reject: reject
              });
            });
          } else {
            me.onInvalidToken();
          }
        }

        return Promise.reject(error);
      });
    }
  }]);

  return Config;
}();

export { Config as default };